const reducer = (state = { items: [] }, action) => {
  console.log("ADDING", action);
  switch (action.type) {
    case "ADD_TO_CART":
      const index = state.items.findIndex(
        (item) => item.product.name === action.payload.product.name
      );

      console.log("INDEX", index, state.items[index]);

      return {
        ...state,
        items:
          index >= 0
            ? [
                ...state.items.slice(0, index),
                {
                  ...state.items[index],
                  quantity:
                    Number(state.items[index].quantity) +
                    action.payload.quantity,
                },
                ...state.items.slice(index + 1),
              ]
            : [...state.items, action.payload],
      };

    case "REMOVE_FROM_CART":
      return {
        ...state,
        items: [
          ...state.items.filter((item) => item.product.name !== action.payload),
        ],
      };

    default:
      return state;
  }
};

export default reducer;
